import http from './public'
const basePath = 'https://admin.zhonghaiyy.com'

// 获取讲座分类
export const getChairType = (params) => {
    return http.fetchPost(`${basePath}/api/LectureClass/GetList`, params)
}
// 获取讲座推荐
export const getChairRecommend = (params) => {
    return http.fetchPost(`${basePath}/api/Lecture/LetureRecommendSearch`, params)
}
// 获取讲座banner
export const getLetureBanner = (params) => {
    return http.fetchPost(`${basePath}/api/Lecture/LetureBanner`, params)
}

// 获取讲座列表
export const getLetureSearch = (params) => {
    return http.fetchPost(`${basePath}/api/Lecture/Search`, params)
}
// 获取讲师列表
export const getLetureMember = (params) => {
    return http.fetchPost(`${basePath}/api/Member/Search`, params)
}
// 获取讲座详情
export const getLetureInfo = (params, header) => {
    return http.fetchPost(`${basePath}/api/Lecture/GetInfo`, params, header)
}
// 获取讲座相关推荐
export const getLetureInfoRelated = (params,header) => {
    return http.fetchPost(`${basePath}/api/Lecture/RelatedLecture`, params,header)
}
// 获取相关药品
export const getRelatedMedicine = (params,header) => {
    return http.fetchPost(`${basePath}/api/MedicineLibrary/RelatedMedicine`, params,header)
}
// 获取讲座评论
export const getLectureReviewss = (params) => {
    return http.fetchPost(`${basePath}/api/LectureReviewss/List`, params)
}
// 发表评论
export const addLectureReviewss = (params, header) => {
    return http.fetchPost(`${basePath}/api/LectureReviewss/Add`, params, header)
}

// 收藏讲座
export const addLectureFavorite = (params, header) => {
    return http.fetchPost(`${basePath}/api/LectureFavorite/Add`, params, header)
}
// 取消收藏讲座
export const quitLectureReviewss = (params, header) => {
    return http.fetchPost(`${basePath}/api/LectureFavorite/Quit`, params, header)
}
// 点赞讲座
export const addLectureLikes = (params, header) => {
    return http.fetchPost(`${basePath}/api/LectureLikes/Add`, params, header)
}
// 取消点赞讲座
export const quitLectureLikes = (params, header) => {
    return http.fetchPost(`${basePath}/api/LectureLikes/Quit`, params, header)
}
// 关注讲师
export const addLecturerAttention = (params, header) => {
    return http.fetchPost(`${basePath}/api/LecturerAttention/Add`, params, header)
}
// 取消关注讲师
export const quitLecturerAttention = (params, header) => {
    return http.fetchPost(`${basePath}/api/LecturerAttention/Quit`, params, header)
}
// 获取讲师详情
export const userDetail = (params, header) => {
    return http.fetchPost(`${basePath}/api/Member/Get`, params, header)
}
// 上传视频文件
export const Upload = (params, header) => {
    return http.fetchPost(`${basePath}/api/_file/Upload`, params, header)
}
// 上传视频文件
export const UploadImage = (params, header) => {
    return http.fetchPost(`${basePath}/api/_file/UploadImage`, params, header)
}
// 发布讲座
export const LectureAdd = (params, header) => {
    return http.fetchPost(`${basePath}/api/Lecture/Add`, params, header)
}
//获取视频文件

export const GetFile = (params, header) => {
    return http.fetchPost(`${basePath}/api/Member/GetFileInfoWithId`, params, header)
}
//申请讲师

export const ApplicationLecturer = (params, header) => {
    return http.fetchPost(`${basePath}/api/Member/ApplicationLecturer`, params, header)
}
// 刷新Token

export const RefreshToken = (params) => {
    return http.fetchPost(`${basePath}/api/_Account/RefreshToken?refreshToken=${params}` )
}
//删除讲座
export const LectureDelete = (params, header) => {
    return http.fetchPost(`${basePath}/api/Lecture/Delete`,  params, header )
}
// 修改讲座
export const LectureEdit = (params, header) => {
    return http.fetchPost(`${basePath}/api/Lecture/Edit`, params, header)
}


// WEBPACK FOOTER //
// ./src/api/chair.js